import { isAxiosError } from "axios";

import { defaultQueryRetry } from "@/providers/QueryClientProviderWrapper";
import type { CustomAxiosRequestConfig } from "@/types/common.types";

/**
 * A read the server refused with 403, which the screen states inline as "You don't have access"
 * (the person record's tabs, SERV-3576, D260 decision 9; a work order's Request to Pay and
 * Proposals lists, SERV-3560) rather than as an error or an empty list.
 */
export const isReadRefused = (error: unknown): boolean =>
  isAxiosError(error) && error.response?.status === 403;

/**
 * SERV-3560: sent with a read whose screen states a 403 itself but has no inline state for any
 * other failure, so only the refusal skips the global toast.
 */
export const READ_REFUSAL_INLINE_CONFIG: CustomAxiosRequestConfig = {
  suppressErrorAlertStatuses: [403],
};

/** A retry would only be refused again; any other failure keeps the app's retry. */
export const retryUnlessReadRefused = (failureCount: number, error: unknown): boolean =>
  !isReadRefused(error) && defaultQueryRetry(failureCount, error);

/**
 * SERV-3593: the app's one retry (none on a 401 or a refusal) without its "Server Error" toast,
 * for a read started where nothing shows it; the screens that do show it state a failure inline.
 */
export const retryQuietlyUnlessReadRefused = (failureCount: number, error: unknown): boolean =>
  !isReadRefused(error) &&
  !(isAxiosError(error) && error.response?.status === 401) &&
  failureCount < 1;
